import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT } from '../data/constants';
export function Guarantee() {
  return <section className="bg-leaf-soft py-5 sm:py-7" data-id="element-63" data-mp="1o33u6h0ytshr">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 px-4 text-center sm:flex-row sm:gap-5 sm:px-6 sm:text-left" data-id="element-64" data-mp="22368jta2e3s9">
        <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full border-4 border-gold bg-forest text-white sm:h-24 sm:w-24" data-id="element-65" data-mp="1x5mw8ywxg12y">
          <ShieldCheckIcon className="h-7 w-7 text-gold sm:h-8 sm:w-8" strokeWidth={2} aria-hidden="true" data-id="element-66" data-mp="14fxs4cox7kx4" />
          <span className="mt-0.5 font-display text-xs font-extrabold uppercase leading-none" data-id="element-67" data-mp="1j52d21n3o38x">
            7 days
          </span>
        </div>
        <div data-id="element-68" data-mp="1ec9a9jb6z4zh">
          <h2 className="text-xl leading-none text-forest sm:text-3xl" data-id="element-69" data-mp="1ebr1xob990b7">
            Your purchase is <span className="text-leaf" data-id="element-70" data-mp="qmexf1qvhgf8">100% protected</span>
          </h2>
          <p className="mt-1.5 text-sm leading-snug text-ink sm:text-base" data-id="element-71" data-mp="loddkelmhd2p">
            Explore {PRODUCT} for 7 days. Access the complete 6-module professional visual
            reference system and all 5 strategic bonuses. If it isn't right for you, contact
            us within 7 days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}